import { planColor } from '../../lib/planColors';

/** Solid colour swatch tying a recipe to its steps on the timeline. */
export function PlanColorDot({
  colorIndex,
  label,
  size = 10,
  className = '',
}: {
  colorIndex: number;
  /** Recipe title — announced to screen readers, which cannot see the colour. */
  label?: string | undefined;
  size?: number;
  className?: string;
}) {
  const color = planColor(colorIndex);
  return (
    <span
      className={`inline-block shrink-0 rounded-full ${className}`}
      style={{ backgroundColor: color.dot, width: size, height: size }}
      role={label ? 'img' : 'presentation'}
      aria-label={label ? `${label} colour` : undefined}
      aria-hidden={label ? undefined : true}
    />
  );
}
